module.exports = __webpack_public_path__ + "public/img/ilmu dasar kepegawaian untuk pegawai personalia-2.f174b530.png";